export default "__VITE_ASSET__DMmBrJzG__"